<div class="packs">
  <header class="packs__header">
    <div>
      <h1 class="packs__title">
        <span class="packs__title-icon">
          <i class="fa-solid fa-tags" aria-hidden="true"></i>
        </span>
        {{ 'PACKS.TITLE' | translate }}
      </h1>
      <p class="packs__subtitle">{{ 'PACKS.SUBTITLE' | translate }}</p>
    </div>
  </header>

  @if (!canWrite) { <app-read-only-notice></app-read-only-notice> }

  @if (isLoading) {
    <p class="packs__state">{{ 'COMMON.LOADING' | translate }}</p>
  } @else if (hasError) {
    <div class="packs__state">
      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      <p>{{ 'PACKS.ERROR_LOAD' | translate }}</p>
    </div>
  } @else {
    <div class="packs__layout">

      <!-- Les packs : peu nombreux et stables, une liste suffit. -->
      <nav class="packs__list" [attr.aria-label]="'PACKS.TITLE' | translate">
        @for (pack of packs; track pack.id) {
          <button type="button" class="packs__card"
                  [class.is-active]="selected?.id === pack.id"
                  (click)="select(pack)">
            <span class="packs__card-name">{{ pack.nameFr }}</span>
            <span class="packs__card-code">{{ pack.code }}</span>
            <span class="packs__card-flags">
              @if (!pack.isActive) {
                <span class="packs__flag packs__flag--off">{{ 'PACKS.INACTIVE' | translate }}</span>
              }
              @if (pack.isHighlighted) {
                <span class="packs__flag packs__flag--star">{{ 'PACKS.HIGHLIGHTED' | translate }}</span>
              }
              @if (pack.pricingMode === 'flat_rate') {
                <span class="packs__flag packs__flag--flat">{{ 'PACKS.FLAT_RATE' | translate }}</span>
              }
              @if (pack.pricingMode === 'on_request') {
                <span class="packs__flag packs__flag--quote">{{ 'PACKS.ON_REQUEST' | translate }}</span>
              }
            </span>
          </button>
        }
      </nav>

      @if (selected; as pack) {
        <div class="packs__detail">

          <!-- Libellés : le site affiche le nom du pack dans la langue du visiteur. -->
          <section class="packs__panel">
            <h2 class="packs__panel-title">{{ 'PACKS.LABELS' | translate }}</h2>
            <div class="packs__fields">
              <label class="packs__field">
                <span>{{ 'PACKS.NAME_FR' | translate }}</span>
                <input type="text" [(ngModel)]="pack.nameFr" [disabled]="!canWrite" />
              </label>
              <label class="packs__field">
                <span>{{ 'PACKS.NAME_AR' | translate }}</span>
                <input type="text" dir="rtl" [(ngModel)]="pack.nameAr" [disabled]="!canWrite" />
              </label>
              <label class="packs__field">
                <span>{{ 'PACKS.NAME_EN' | translate }}</span>
                <input type="text" [(ngModel)]="pack.nameEn" [disabled]="!canWrite" />
              </label>
              <label class="packs__field packs__field--narrow">
                <span>{{ 'PACKS.ORDER' | translate }}</span>
                <input type="number" min="1" [(ngModel)]="pack.displayOrder" [disabled]="!canWrite" />
              </label>
            </div>

            <div class="packs__toggles">
              <label class="packs__check">
                <input type="checkbox" [(ngModel)]="pack.isActive" [disabled]="!canWrite" />
                <span>{{ 'PACKS.IS_ACTIVE' | translate }}</span>
              </label>
              <label class="packs__check">
                <input type="checkbox" [(ngModel)]="pack.isHighlighted" [disabled]="!canWrite" />
                <span>{{ 'PACKS.IS_HIGHLIGHTED' | translate }}</span>
              </label>
            </div>
          </section>

          <!-- Comment la formule se vend : en entier ou à la carte, avec ou
               sans remise, et pour la seule classe achetée ou non. Ces trois
               options commandent le tunnel d'inscription. -->
          <section class="packs__panel">
            <h2 class="packs__panel-title">{{ 'PACKS.SELLING' | translate }}</h2>

            <div class="packs__toggles">
              <label class="packs__check">
                <input type="checkbox" [(ngModel)]="pack.requiresAllSubjects" [disabled]="!canWrite" />
                <span>{{ 'PACKS.REQUIRES_ALL' | translate }}</span>
              </label>
            </div>
            <p class="packs__hint">{{ 'PACKS.REQUIRES_ALL_HINT' | translate }}</p>

            <div class="packs__fields">
              <label class="packs__field packs__field--narrow">
                <span>{{ 'PACKS.DISCOUNT' | translate }}</span>
                <!-- Sans objet quand tout est imposé : tout le monde prend
                     tout, et la remise n'est qu'un prix plus bas écrit à deux
                     endroits. Désactivée plutôt que masquée, pour qu'on voie
                     pourquoi elle ne s'applique pas. -->
                <input type="number" min="0" max="100" step="1"
                       [(ngModel)]="pack.allSubjectsDiscountPercent"
                       [disabled]="!canWrite || (pack.requiresAllSubjects)" />
              </label>
              <label class="packs__field packs__field--narrow">
                <span>{{ 'PACKS.DISCOUNT_PARTIAL' | translate }}</span>
                <!-- Sans objet pour la même raison : une formule imposée
                     n'admet aucune sélection partielle à récompenser. -->
                <input type="number" min="0" max="100" step="1"
                       [(ngModel)]="pack.partialSubjectsDiscountPercent"
                       [disabled]="!canWrite || (pack.requiresAllSubjects)" />
              </label>
            </div>
            <p class="packs__hint">
              {{ (pack.requiresAllSubjects ? 'PACKS.DISCOUNT_MOOT' : 'PACKS.DISCOUNT_HINT') | translate }}
            </p>

            @if (canWrite) {
              <div class="packs__toggles">
                <button type="button" class="packs__btn packs__btn--primary"
                        (click)="savePack()" [disabled]="isSaving">
                  <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                  {{ 'PACKS.SAVE_PACK' | translate }}
                </button>
              </div>
            }
          </section>

          <!-- Ce que le pack ouvre dans l'espace élève : une case par entrée
               du menu élève. Seuls le tableau de bord et le profil restent
               ouverts à tous. -->
          <section class="packs__panel">
            <h2 class="packs__panel-title">{{ 'PACKS.FEATURES' | translate }}</h2>
            <p class="packs__hint">{{ 'PACKS.FEATURES_HINT' | translate }}</p>

            @if (featuresUnavailable) {
              <p class="packs__hint">{{ 'PACKS.FEATURES_ERROR_LOAD' | translate }}</p>
            }

            <!-- Le même sélecteur que « Profils et accès » : un en-tête par
                 module, ses fonctionnalités à cocher. -->
            <app-permission-picker
              [modules]="featureModules"
              [selected]="packFeatures"
              [readOnly]="!canWrite || !featuresLoaded"
              (toggled)="toggleFeature($event)"
              (moduleToggled)="toggleFeatureModule($event)"></app-permission-picker>

            @if (canWrite) {
              <div class="packs__toggles">
                <button type="button" class="packs__btn packs__btn--primary"
                        (click)="saveFeatures()" [disabled]="isSavingFeatures || !featuresLoaded">
                  <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                  {{ 'PACKS.SAVE_FEATURES' | translate }}
                </button>
              </div>
            }
          </section>

          <!-- Prix par classe : c'est ce que le site annonce, et ce qui est
               facturé à qui prend toute la classe. Une case laissée vide fait
               retomber la classe sur la somme de ses matières — le montant du
               repli est affiché en filigrane pour qu'on sache ce que verra un
               visiteur sans avoir à ouvrir le site. -->
          <section class="packs__panel">
            <div class="packs__panel-head">
              <h2 class="packs__panel-title">{{ 'PACKS.DISPLAY_PRICES' | translate }}</h2>
              @if (isDirty) {
                <span class="packs__dirty">{{ 'PACKS.UNSAVED' | translate }}</span>
              }
            </div>
            <p class="packs__hint">{{ 'PACKS.DISPLAY_HINT' | translate }}</p>
            @if (pack.pricingMode === 'per_subject') {
              <p class="packs__hint">{{ 'PACKS.PRICES_HINT' | translate }}</p>
            }
            <p class="packs__hint">{{ 'PACKS.LEVEL_DISCOUNT_HINT' | translate }}</p>

            <!-- L'annuel se déduit du mensuel : neuf mois facturés par année
                 scolaire, de septembre à mai. Le nombre se règle ici et n'est
                 pas enregistré — c'est l'entrée d'un calcul, pas une règle du
                 serveur, qui facture les annuels tels qu'ils sont saisis. Le
                 bouton ne touche qu'aux cases vides, sauf demande explicite. -->
            @if (canWrite && pack.pricingMode !== 'on_request') {
              <div class="packs__toggles">
                <label class="packs__field packs__field--narrow">
                  <span>{{ 'PACKS.YEARLY_MONTHS' | translate }}</span>
                  <input type="number" [min]="MIN_YEARLY_MONTHS" [max]="MAX_YEARLY_MONTHS" step="1"
                         [(ngModel)]="yearlyMonths" />
                </label>
                <label class="packs__check">
                  <input type="checkbox" [(ngModel)]="overwriteYearly" />
                  <span>{{ 'PACKS.FILL_YEARLY_OVERWRITE' | translate }}</span>
                </label>
                <button type="button" class="packs__btn" (click)="fillYearly()"
                        [disabled]="isSaving || !yearlyMonthsValid">
                  <i class="fa-solid fa-calculator" aria-hidden="true"></i>
                  {{ 'PACKS.FILL_YEARLY' | translate }}
                </button>
              </div>
              @if (yearlyMonthsValid) {
                <p class="packs__hint">{{ 'PACKS.FILL_YEARLY_HINT' | translate: { mois: yearlyMonths } }}</p>
              } @else {
                <p class="packs__hint">{{ 'PACKS.FILL_YEARLY_INVALID' | translate }}</p>
              }
            }

            <!-- Les totaux reportés et les annuels calculés ne sont pas encore
                 en base : la case les montre, mais un visiteur ne les verra
                 qu'après « mettre à jour ». Le dire ici évite de croire la
                 page publiée. -->
            @if (hasPrefilled || hasComputed) {
              <div class="packs__gaps packs__gaps--proposal" role="status">
                <p class="packs__gaps-title">
                  <i class="fa-solid fa-wand-magic-sparkles" aria-hidden="true"></i>
                  {{ (hasPrefilled ? 'PACKS.PREFILLED_TITLE' : 'PACKS.COMPUTED_TITLE') | translate }}
                </p>
                @if (hasPrefilled) {
                  <p class="packs__gaps-note packs__gaps-note--soft">
                    {{ 'PACKS.PREFILLED_INTRO' | translate }}
                  </p>
                }
                @if (hasComputed) {
                  <p class="packs__gaps-note packs__gaps-note--soft">
                    {{ 'PACKS.COMPUTED_INTRO' | translate: { mois: computedMonths } }}
                  </p>
                }
              </div>
            }

            <!-- Un écart entre le prix d'une classe et le total de ses matières
                 se paie à l'inscription : le premier s'applique à qui prend la
                 classe entière, le second dès qu'on décoche. L'alerte arrive au
                 moment de la décision ; ce bandeau la rappelle ensuite. -->
            @if (gaps.length > 0) {
              <div class="packs__gaps packs__gaps--divergence" role="alert">
                <p class="packs__gaps-title">
                  <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                  {{ 'PACKS.GAP_TITLE' | translate }}
                </p>
                <ul class="packs__gaps-list">
                  @for (gap of gaps; track gap.pathTitle + gap.period) {
                    <li [class.is-inversion]="isInversion(gap)">
                      {{ 'PACKS.GAP_LINE' | translate: {
                           classe: gap.pathTitle,
                           periode: ('PACKS.PERIOD_' + gap.period.toUpperCase()) | translate,
                           prix: gap.levelAmount,
                           total: gap.subjectsTotal
                         } }}
                    </li>
                  }
                </ul>
                @if (hasIncomplete) {
                  <p class="packs__gaps-note packs__gaps-note--soft">
                    {{ 'PACKS.GAP_INCOMPLETE' | translate }}
                  </p>
                }
                @if (hasInversion) {
                  <p class="packs__gaps-note">{{ 'PACKS.GAP_INVERSION' | translate }}</p>
                }
              </div>
            }

            <!-- Un écart annonce deux prix qui divergent ; ceci annonce qu'il
                 n'y en aura aucun. Deux bandeaux distincts, parce que le
                 second se corrige autrement : il manque des tarifs, il n'y a
                 pas d'arbitrage à faire. -->
            @if (unsellable.length > 0) {
              <div class="packs__gaps packs__gaps--blocking" role="alert">
                <p class="packs__gaps-title">
                  <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
                  {{ 'PACKS.UNSELLABLE_TITLE' | translate }}
                </p>
                <p class="packs__gaps-note">{{ 'PACKS.UNSELLABLE_INTRO' | translate }}</p>
                <ul class="packs__gaps-list">
                  @for (slot of unsellable; track slot.pathId + slot.period) {
                    <li>
                      {{ 'PACKS.UNSELLABLE_LINE' | translate: {
                           classe: slot.pathTitle,
                           periode: ('PACKS.PERIOD_' + slot.period.toUpperCase()) | translate,
                           manquantes: slot.missing
                         } }}
                    </li>
                  }
                </ul>
              </div>
            }

            <!-- Un onglet par cycle : les trois grilles empilées faisaient une
                 page de plus de cent lignes. Chaque onglet porte un repère
                 quand son cycle a un écart, une classe invendable ou une
                 proposition à enregistrer — sinon un défaut dans un onglet
                 fermé ne se verrait plus que dans le texte des bandeaux. -->
            @if (levelGroups.length > 0) {
              <div class="packs__tabs" role="tablist" [attr.aria-label]="'PACKS.DISPLAY_PRICES' | translate">
                @for (group of levelGroups; track group.level; let i = $index) {
                  <button type="button" role="tab" class="packs__tab"
                          [id]="'packs-tab-' + group.level"
                          [attr.aria-selected]="activeLevel() === group.level"
                          [attr.aria-controls]="'packs-panel-' + group.level"
                          [attr.tabindex]="activeLevel() === group.level ? 0 : -1"
                          (click)="selectLevel(group.level)"
                          (keydown)="onTabKeydown($event, i)">
                    {{ ('PACKS.LEVEL_' + group.level.toUpperCase()) | translate }}
                    @if (levelMark(group.level); as mark) {
                      <span class="packs__tab-mark" [class]="'packs__tab-mark packs__tab-mark--' + mark"
                            [attr.title]="('PACKS.TAB_MARK_' + mark.toUpperCase()) | translate">
                        <i class="fa-solid" aria-hidden="true"
                           [class.fa-circle-xmark]="mark === 'unsellable'"
                           [class.fa-triangle-exclamation]="mark === 'gap'"
                           [class.fa-wand-magic-sparkles]="mark === 'pending'"></i>
                        <span class="packs__sr-only">{{ ('PACKS.TAB_MARK_' + mark.toUpperCase()) | translate }}</span>
                      </span>
                    }
                  </button>
                }
              </div>
            }

            @if (activeGroup; as group) {
              <div class="packs__group" role="tabpanel"
                   [id]="'packs-panel-' + group.level"
                   [attr.aria-labelledby]="'packs-tab-' + group.level">

                <div class="packs__table-wrap">
                  <table class="packs__table">
                    <thead>
                      <tr>
                        <th scope="col">{{ 'PACKS.GRADE' | translate }}</th>
                        @for (period of periods; track period) {
                          <th scope="col" class="packs__num">
                            {{ ('PACKS.PERIOD_' + period.toUpperCase()) | translate }}
                          </th>
                        }
                        <th scope="col" class="packs__num">
                          {{ 'PACKS.LEVEL_DISCOUNT' | translate }}
                        </th>
                        <th scope="col" class="packs__num">
                          <span class="packs__sr-only">{{ 'PACKS.UPDATE_CLASS' | translate }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (path of group.paths; track path.id) {
                        <tr class="packs__class-row" [class.has-gap]="classHasGap(path.id)">
                          <th scope="row" class="packs__subject">
                            <!-- Les matières se déplient sous la classe plutôt
                                 que dans un tableau à part : le prix de la
                                 classe et la somme de ses matières doivent se
                                 comparer d'un coup d'œil, et non d'une section
                                 à l'autre. -->
                            @if (pack.pricingMode === 'per_subject' && rowsOf(path.id).length > 0) {
                              <button type="button" class="packs__expand"
                                      (click)="toggleExpand(path.id)"
                                      [attr.aria-expanded]="isExpanded(path.id)"
                                      [attr.aria-label]="((isExpanded(path.id) ? 'PACKS.HIDE_SUBJECTS' : 'PACKS.SHOW_SUBJECTS') | translate) + ' — ' + path.title">
                                <i class="fa-solid"
                                   [class.fa-chevron-down]="isExpanded(path.id)"
                                   [class.fa-chevron-right]="!isExpanded(path.id)"
                                   aria-hidden="true"></i>
                              </button>
                            }
                            {{ path.title }}
                            @if (classHasGap(path.id)) {
                              <i class="fa-solid fa-triangle-exclamation packs__row-warn"
                                 [attr.title]="'PACKS.GAP_TITLE' | translate"
                                 aria-hidden="true"></i>
                            }
                          </th>
                          @for (period of periods; track period) {
                            <td class="packs__num"
                                [attr.data-label]="('PACKS.PERIOD_' + period.toUpperCase()) | translate">
                              <!-- Une case vide reçoit le total des matières de
                                   sa classe : sans cela, une grille à laquelle
                                   il manque un tarif ne publiait aucun prix.
                                   Le filigrane ne sert donc plus qu'aux cases
                                   que l'administration vide exprès, et il
                                   montre `fallbackTotal` — ce que le site
                                   facturera vraiment, pas une somme partielle
                                   qu'il refuserait. -->
                              <input type="number" min="0" step="1" class="packs__amount"
                                     [class.is-unsellable]="isUnsellable(path.id, period)"
                                     [class.is-prefilled]="isPrefilled(path.id, period) || isComputed(path.id, period)"
                                     [(ngModel)]="display[key(path.id, period)]"
                                     (ngModelChange)="onAmountChange(key(path.id, period))"
                                     [placeholder]="fallbackTotal(path.id, period) ?? ''"
                                     [attr.title]="isUnsellable(path.id, period)
                                                     ? ('PACKS.UNSELLABLE_CELL' | translate)
                                                     : isPrefilled(path.id, period)
                                                       ? ('PACKS.PREFILLED_CELL' | translate)
                                                       : isComputed(path.id, period)
                                                         ? ('PACKS.COMPUTED_CELL' | translate)
                                                         : null"
                                     [attr.aria-label]="path.title + ' — ' + (('PACKS.PERIOD_' + period.toUpperCase()) | translate)" [disabled]="!canWrite" />
                              @if (isUnsellable(path.id, period)) {
                                <span class="packs__unsellable">
                                  {{ 'PACKS.UNSELLABLE_BADGE' | translate }}
                                </span>
                              } @else if (isPrefilled(path.id, period)) {
                                <span class="packs__prefilled">
                                  {{ 'PACKS.PREFILLED_BADGE' | translate }}
                                </span>
                              } @else if (isComputed(path.id, period)) {
                                <span class="packs__prefilled">
                                  {{ 'PACKS.COMPUTED_BADGE' | translate: { mois: computedMonths } }}
                                </span>
                              }
                            </td>
                          }
                          <!-- La remise vise la classe, pas la périodicité :
                               une seule case par ligne. Trois taux à tenir
                               cohérents pour un seul geste commercial
                               n'auraient rien apporté.

                               Vide et zéro ne disent pas la même chose, et
                               c'est la distinction qui compte : vide, la
                               classe retombe sur les remises du pack ; à
                               zéro, elle les refuse. C'est la seule façon
                               d'exclure une classe d'une remise générale. -->
                          <td class="packs__num"
                              [attr.data-label]="'PACKS.LEVEL_DISCOUNT' | translate">
                            <input type="number" min="0" max="100" step="1"
                                   class="packs__amount packs__amount--percent"
                                   [(ngModel)]="discounts[path.id]"
                                   (ngModelChange)="onAmountChange()"
                                   [placeholder]="'PACKS.LEVEL_DISCOUNT_EMPTY' | translate"
                                   [attr.title]="'PACKS.LEVEL_DISCOUNT_CELL' | translate"
                                   [attr.aria-label]="('PACKS.LEVEL_DISCOUNT' | translate) + ' — ' + path.title" [disabled]="!canWrite" />
                          </td>

                          <!-- Mise à jour depuis la ligne. Les deux endpoints
                               remplacent en bloc : le bouton envoie donc les
                               deux grilles entières, sans quoi les autres
                               classes seraient effacées. Ce qu'il cible, c'est
                               la vérification qui suit — l'alerte ne parle que
                               de cette classe. -->
                          <td class="packs__num">
                            @if (canWrite) {
                            <button type="button" class="packs__row-btn"
                                    (click)="updateClass(path.id)"
                                    [disabled]="isSaving"
                                    [attr.aria-label]="('PACKS.UPDATE_CLASS' | translate) + ' — ' + path.title">
                              @if (savingPathId === path.id) {
                                <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                              } @else {
                                <i class="fa-solid fa-rotate" aria-hidden="true"></i>
                              }
                              <span>{{ 'PACKS.UPDATE' | translate }}</span>
                            </button>
                            }
                          </td>
                        </tr>

                        <!-- Rien à déplier sans matière : le sous-total seul
                             afficherait une ligne « total » à trois tirets
                             sous une classe qui n'a rien à totaliser. -->
                        @if (isExpanded(path.id) && rowsOf(path.id).length > 0) {
                          @for (row of rowsOf(path.id); track row.subjectId) {
                            <!-- Une matière inactive garde sa ligne et ses
                                 tarifs, atténuée et étiquetée : le site ne la
                                 vend pas, et elle ne compte dans aucun total
                                 ci-dessous. -->
                            <tr class="packs__subrow" [class.is-inactive]="!row.isActive">
                              <th scope="row" class="packs__subject">
                                <span class="packs__subject-name">{{ row.subjectName }}</span>
                                @if (!row.isActive) {
                                  <span class="packs__flag packs__flag--off"
                                        [attr.title]="'PACKS.SUBJECT_INACTIVE_HINT' | translate">
                                    {{ 'PACKS.SUBJECT_INACTIVE' | translate }}
                                  </span>
                                }
                              </th>
                              @for (period of periods; track period) {
                                <td class="packs__num"
                                    [attr.data-label]="('PACKS.PERIOD_' + period.toUpperCase()) | translate">
                                  <input type="number" min="0" step="1" class="packs__amount"
                                         [class.is-prefilled]="isRowComputed(row.subjectId, period)"
                                         [(ngModel)]="row.amounts[period]"
                                         (ngModelChange)="onAmountChange(rowKey(row.subjectId, period))"
                                         [attr.title]="isRowComputed(row.subjectId, period) ? ('PACKS.COMPUTED_CELL' | translate) : null"
                                         [attr.aria-label]="row.subjectName + ' — ' + (('PACKS.PERIOD_' + period.toUpperCase()) | translate)" [disabled]="!canWrite" />
                                </td>
                              }
                              <td></td>
                              <td></td>
                            </tr>
                          }
                          <tr class="packs__subtotal">
                            <th scope="row">{{ 'PACKS.TOTAL_FULL' | translate }}</th>
                            @for (period of periods; track period) {
                              <td class="packs__num" [class.is-gap]="gapFor(path.id, period)"
                                  [attr.data-label]="('PACKS.PERIOD_' + period.toUpperCase()) | translate">
                                {{ subjectsTotal(path.id, period) ?? '—' }}
                                @if (gapFor(path.id, period); as gap) {
                                  <span class="packs__delta">
                                    ({{ gap.subjectsTotal > gap.levelAmount ? '+' : '' }}{{ gap.subjectsTotal - gap.levelAmount }})
                                  </span>
                                }
                              </td>
                            }
                            <td></td>
                            <td></td>
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }

            @if (levelGroups.length === 0) {
              <p class="packs__state">{{ 'PACKS.NO_GRADES' | translate }}</p>
            }

            @if (canWrite) {
              <div class="packs__actions">
                <button type="button" class="packs__btn packs__btn--primary"
                        (click)="save()" [disabled]="isSaving || !isDirty">
                  <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                  {{ (isSaving ? 'PACKS.SAVING' : 'PACKS.SAVE_DISPLAY') | translate }}
                </button>
              </div>
            }
          </section>

          <!-- Une formule au forfait ou sur devis n'a pas de grille par
               matière : ses lignes de classe ne se déplient pas, et le rappel
               ci-dessous dit pourquoi. -->
          @if (pack.pricingMode === 'flat_rate') {
            <p class="packs__quote">
              <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
              {{ 'PACKS.FLAT_HINT' | translate }}
            </p>
          } @else if (pack.pricingMode !== 'per_subject') {
            <p class="packs__quote">
              <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
              {{ 'PACKS.ON_REQUEST_HINT' | translate }}
            </p>
          }
        </div>
      }
    </div>
  }
</div>
